import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar, WhatsAppFloat } from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import { FloatingSocial } from './components/common/SocialIcons';
import HomePage from './pages/HomePage';
import BooksPage from './pages/BooksPage';
import PoetsPage from './pages/PoetsPage';
import ArticlesPage from './pages/ArticlesPage';
import ArticleSinglePage from './pages/ArticleSinglePage';
import SubmitArticlePage from './pages/SubmitArticlePage';
import GalleryPage from './pages/GalleryPage';
import NewsPage from './pages/NewsPage';
import ContactPage from './pages/ContactPage';
import AdminPage from './pages/AdminPage';
import NotFoundPage from './pages/NotFoundPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  if (isAdmin) return children;
  return (
    <>
      <FloatingSocial />
      <Navbar />
      {children}
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/books" element={<BooksPage />} />
          <Route path="/poets" element={<PoetsPage />} />
          <Route path="/articles" element={<ArticlesPage />} />
          <Route path="/articles/:id" element={<ArticleSinglePage />} />
          <Route path="/submit-article" element={<SubmitArticlePage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin/*" element={<AdminPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
